import "@google/model-viewer";
import { h } from "preact";
import { useRef, useEffect, useState } from "preact/hooks";

const spinnerStyle = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none";
const svgStyle = "width:2rem;height:2rem;color:#a1a1aa;animation:spin 1s linear infinite";

const Spinner = h(
  "div",
  { slot: "progress-bar", style: spinnerStyle },
  h(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", style: svgStyle, "aria-hidden": "true" },
    h("style", null, "@keyframes spin{to{transform:rotate(360deg)}}"),
    h("circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", "stroke-width": "2", "stroke-opacity": "0.25" }),
    h("path", { d: "M12 2a10 10 0 0 0-10 10", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-opacity": "0.75", fill: "none" })
  )
);

export default function ModelViewer({ src, classes }) {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onLoad = () => setLoaded(true);
    el.addEventListener("load", onLoad);
    return () => el.removeEventListener("load", onLoad);
  }, []);

  return h(
    "model-viewer",
    {
      ref,
      src,
      "camera-controls": true,
      "camera-orbit": "0deg 90deg 210%",
      "min-camera-orbit": "auto auto 210%",
      "tone-mapping": "neutral",
      "shadow-intensity": "1",
      loading: "lazy",
      style: "--progress-bar-height:0px",
      class: ["w-full h-full select-none", classes].filter(Boolean).join(" "),
    },
    loaded ? null : Spinner
  );
}